import React from "react";

// ================= ICONS =================
// FontAwesome Icons (Fa)
import {
  FaHome,
  FaCalculator,
  FaRupeeSign,
  FaTasks,
  FaClipboardCheck,
  FaUserTie,
  FaFileInvoiceDollar,
  FaSitemap,
  FaBuilding,
} from "react-icons/fa";

// Material Design Icons (Md)
import {
  MdLock,
  MdWork,
  MdOutlineSubscriptions,
  MdWorkOff,
  MdAdminPanelSettings,
  MdOutlineDashboardCustomize,
  MdSettingsAccessibility,
  MdSupervisedUserCircle,
  MdAssignmentInd,
  MdRule,
  MdPolicy,
  MdFolderOpen,
  MdCardGiftcard,
  MdOutlineLabel,
  MdOutlineAddBox,
  MdCalendarToday,
  MdPlaylistAddCheck,
  MdSettings,
  MdGroupWork,
  MdChat,
  MdPriceChange,
} from "react-icons/md";

// ================= AUTH =================
import SignIn from "views/auth/SignIn";
import Register from "views/auth/Register";

// ================= SUBSCRIPTION =================
import SubscriptionPlans from "views/subscription/SubscriptionPlans";

// ================= ADMIN =================
import Dashboard from "views/admin/Dasboard/Dashboard";

// ================= PLANS superadmin =================
import Plans from "views/admin/plans/Plans";

// ================= ROLE management superadmin =================
import Role from "views/admin/roleManagement/role/Role";
import Permission from "views/admin/roleManagement/permission/Permission";
import RoleAccess from "views/admin/roleManagement/roleAccess/RoleAccess";

// ================ COMPANY =================
import CompanyDashboard from "views/company/dashboard/CompanyDashboard";

import Employee from "views/company/userManagement/employee/Employee";
import Department from "views/company/userManagement/department/Department";
import Designation from "views/company/userManagement/designation/Designation";
import OrgTree from "views/company/userManagement/orgTree/OrgTree";

import Profile from "views/company/profile/Profile";
import EmployeeProfile from "views/employee/profile/Profile";

import ApplyLeave from "views/company/leaveManagement/applyLeave/ApplyLeave";
import LeaveDetails from "views/company/leaveManagement/leaveDetails/LeaveDetails";
import LeaveType from "views/company/leaveManagement/leaveType/LeaveType";
import Holiday from "views/company/leaveManagement/holiday/Holiday";
import LeaveAdjustmentReimbursement from "views/company/leaveManagement/leaveAdjustmentReimbursement/LeaveAdjustmentReimbursement";

import SalaryStructure from "views/company/payrollManagement/salaryStructure/SalaryStructure";
import SalaryConfiguration from "views/company/payrollManagement/salaryConfiguration/SalaryConfiguration";
import ProcessPayroll from "views/company/payrollManagement/processPayroll/ProcessPayroll";

import AttendanceRecords from "views/company/attendanceManagement/attendanceRecords/AttendanceRecords";
import TeamAttendance from "views/company/attendanceManagement/teamAttendance/TeamAttendance";
import AttendancePolicy from "views/company/attendanceManagement/attendancePolicy/AttendancePolicy";
import MyAttendance from "views/company/attendanceManagement/myAttendance/MyAttendance";
import Regularization from "views/company/attendanceManagement/regularization/Regularization";

import Overview from "views/company/projectManagement/overview/Overview";
import Project from "views/company/projectManagement/project/Project";
import ProjectDetails from "views/company/projectManagement/project/ProjectDetails";
import ProjectReport from "views/company/projectManagement/report/ProjectReport";
import Task from "views/company/projectManagement/task/Task";

import RolePermission from "views/company/roleManagement/rolePermission";
import CompanyRole from "views/company/roleManagement/companyRole";
import EmployeeRoles from "views/company/roleManagement/employeeRole";

import Requisitions from "views/company/requisition/requisitions";
import MyRequisitions from "views/company/requisition/myRequisitions";
import CreateRequisition from "views/company/requisition/createRequisitions";
import RequisitionWorkflows from "views/company/requisition/requisitionWorkflows";

import Settings from "views/company/settings/Settings";
import Chat from "views/company/chat/Chat";

// ================= GROUP ICONS =================
export const groupIcons = {
  Dashboard: <FaHome className="h-6 w-6" />,
  Plans: <MdOutlineSubscriptions className="h-6 w-6" />,
  "User Management": <MdSupervisedUserCircle className="h-6 w-6" />,
  "Attendance Management": <FaClipboardCheck className="h-6 w-6" />,
  "Leave Management": <MdWorkOff className="h-6 w-6" />,
  "Payroll Management": <FaRupeeSign className="h-6 w-6" />,
  "Project Management": <MdOutlineDashboardCustomize className="h-6 w-6" />,
  "Role Management": <MdAdminPanelSettings className="h-6 w-6" />,
  "Requisition Management": <FaFileInvoiceDollar className="h-6 w-6" />,
  Chat: <MdChat className="h-6 w-6" />,
};

// ================= ROUTES =================
const routes = [
  // DASHBOARD superadmin
  {
    name: "Dashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <FaHome className="h-5 w-5" />,
    component: <Dashboard />,
    showInSidebar: true,
    group: "Dashboard",
    allowedRoles: ["SUPER_ADMIN"],
  },

  // COMPANIES superadmin
  {
    name: "Companies",
    layout: "/admin",
    path: "companies",
    icon: <FaBuilding className="h-5 w-5" />,
    component: <Dashboard />,
    showInSidebar: true,
    group: "Companies",
    allowedRoles: ["SUPER_ADMIN"],
  },

  // PLANS superadmin
  {
    name: "Plans",
    layout: "/admin",
    path: "plans",
    icon: <MdOutlineSubscriptions className="h-5 w-5" />,
    component: <Plans />,
    showInSidebar: true,
    group: "Plans",
    allowedRoles: ["SUPER_ADMIN"],
  },

  // ROLE superadmin
  {
    name: "Role",
    layout: "/admin",
    path: "role",
    icon: <MdAssignmentInd className="h-5 w-5" />,
    component: <Role />,
    showInSidebar: true,
    group: "Role Management",
    allowedRoles: ["SUPER_ADMIN"],
  },

  // PERMISSION superadmin
  {
    name: "Permission",
    layout: "/admin",
    path: "permission",
    icon: <MdRule className="h-5 w-5" />,
    component: <Permission />,
    showInSidebar: true,
    group: "Role Management",
    allowedRoles: ["SUPER_ADMIN"],
  },

  // ROLE ACCESS superadmin
  // {
  //   name: "Role Access",
  //   layout: "/admin",
  //   path: "role-access",
  //   icon: <MdAdminPanelSettings className="h-5 w-5" />,
  //   component: <RoleAccess />,
  //   showInSidebar: true,
  //   group: "Role Management",
  //   allowedRoles: ["SUPER_ADMIN"],
  // },

  // SUBSCRIPTION superadmin
  {
    name: "Subscription Plans",
    layout: "/subscription",
    path: "plans",
    component: <SubscriptionPlans />,
    showInSidebar: false,
  },

  // AUTH
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-5 w-5" />,
    component: <SignIn />,
    showInSidebar: false,
  },
  {
    name: "Register",
    layout: "/auth",
    path: "register",
    icon: <MdLock className="h-5 w-5" />,
    component: <Register />,
    showInSidebar: false,
  },

  // COMPANY USER ROUTES
  {
    name: "Dashboard",
    layout: "/company",
    path: "dashboard",
    icon: <FaHome className="h-5 w-5" />,
    component: <CompanyDashboard />,
    showInSidebar: true,
    group: "Dashboard",
  },
  {
    name: "Chat",
    layout: "/company",
    path: "chat",
    icon: <MdChat className="h-5 w-5" />,
    component: <Chat />,
    showInSidebar: true,
    // group: "Chat",
    // feature: "chat",
    // allowedRoles: ["Company", "Employee"],
  },
  {
    name: "Profile",
    layout: "/company",
    path: "profile",
    icon: <FaUserTie className="h-5 w-5" />,
    component: <Profile />,
    showInSidebar: false,
    group: "User",
  },
  {
    name: "Employee Profile",
    layout: "/company",
    path: "employee/profile",
    icon: <FaUserTie className="h-5 w-5" />,
    component: <EmployeeProfile />,
    showInSidebar: false,
    group: "User",
  },

  // USER MANAGEMENT COMPANY
  {
    name: "Employee",
    layout: "/company",
    path: "employee",
    icon: <MdSupervisedUserCircle className="h-5 w-5" />,
    component: <Employee />,
    showInSidebar: true,
    group: "User Management",
    feature: "employees",
    permissionModule: "employee",
  },
  {
    name: "Department",
    layout: "/company",
    path: "department",
    icon: <MdWork className="h-5 w-5" />,
    component: <Department />,
    showInSidebar: true,
    group: "User Management",
    feature: "employees",
    permissionModule: "department",
  },
  {
    name: "Designation",
    layout: "/company",
    path: "designation",
    icon: <FaUserTie className="h-5 w-5" />,
    component: <Designation />,
    showInSidebar: true,
    group: "User Management",
    feature: "employees",
    permissionModule: "designation",
  },
  {
    name: "Organization Tree",
    layout: "/company",
    path: "organization-tree",
    icon: <FaSitemap className="h-5 w-5" />,
    component: <OrgTree />,
    showInSidebar: true,
    group: "User Management",
    feature: "employees",
    permissionModule: "organization",
  },

  // ATTENDANCE MANAGEMENT COMPANY
  {
    name: "My Attendance",
    layout: "/company",
    path: "my-attendance",
    icon: <FaClipboardCheck className="h-5 w-5" />,
    component: <MyAttendance />,
    showInSidebar: true,
    group: "Attendance Management",
    feature: "attendance",
    // permissionModule: "attendance",
    allowedRoles: ["Employee"]
  },
  {
    name: "Team Attendance",
    layout: "/company",
    path: "team-attendance",
    icon: <MdGroupWork className="h-5 w-5" />,
    component: <TeamAttendance />,
    showInSidebar: true,
    group: "Attendance Management",
    feature: "attendance",
    permissionModule: "team_attendance",
    allowedRoles: ["Employee"],
  },
  {
    name: "Attendance Records",
    layout: "/company",
    path: "attendance-records",
    icon: <MdCalendarToday className="h-5 w-5" />,
    component: <AttendanceRecords />,
    showInSidebar: true,
    group: "Attendance Management",
    feature: "attendance",
    permissionModule: "attendance_records",
  },
  {
    name: "Regularization",
    layout: "/company",
    path: "regularization",
    icon: <MdPlaylistAddCheck className="h-5 w-5" />,
    component: <Regularization />,
    showInSidebar: true,
    group: "Attendance Management",
    feature: "attendance",
    permissionModule: "attendance_regularization",
  },
  {
    name: "Attendance Policy",
    layout: "/company",
    path: "attendance-policy",
    icon: <MdPolicy className="h-5 w-5" />,
    component: <AttendancePolicy />,
    showInSidebar: true,
    group: "Attendance Management",
    feature: "attendance",
    permissionModule: "attendance_policies",
  },
  {
    name: "Attendance",
    layout: "/company",
    path: "attendance",
    icon: <FaClipboardCheck className="h-5 w-5" />,
    component: <TeamAttendance />,
    showInSidebar: false,
    group: "Attendance Management",
    feature: "attendance",
    permissionModule: "attendance",
  },

  // LEAVE MANAGEMENT COMPANY
  {
    name: "My Leaves",
    layout: "/company",
    path: "apply-leave",
    icon: <MdWorkOff className="h-5 w-5" />,
    component: <ApplyLeave />,
    showInSidebar: true,
    group: "Leave Management",
    feature: "leave",
    permissionModule: "apply_leave",
    allowedRoles: ["Employee"],
  },
  {
    name: "Leave Details",
    layout: "/company",
    path: "leave-details",
    icon: <MdPlaylistAddCheck className="h-5 w-5" />,
    component: <LeaveDetails />,
    showInSidebar: true,
    group: "Leave Management",
    feature: "leave",
    permissionModule: "leave_details",
  },
  {
    name: "Leave Type",
    layout: "/company",
    path: "leave-type",
    icon: <MdOutlineLabel className="h-5 w-5" />,
    component: <LeaveType />,
    showInSidebar: true,
    group: "Leave Management",
    feature: "leave",
    permissionModule: "leave_type",
    // allowedRoles: ["Employee"],
  },
  {
    name: "Holiday",
    layout: "/company",
    path: "holiday",
    icon: <MdCardGiftcard className="h-5 w-5" />,
    component: <Holiday />,
    showInSidebar: true,
    group: "Leave Management",
    feature: "leave",
    permissionModule: "holiday",
  },
  {
    name: "Reimbursement & Adjustments",
    layout: "/company",
    path: "leave-adjustment-reimbursement",
    icon: <MdPriceChange className="h-5 w-5" />,
    component: <LeaveAdjustmentReimbursement />,
    showInSidebar: true,
    group: "Leave Management",
    feature: "leave",
    permissionModule: "leave_details",
    allowedRoles: ["Employee"]
  },

  // PAYROLL MANAGEMENT COMPANY
  {
    name: "Salary Structure",
    layout: "/company",
    path: "salary-structure",
    icon: <FaCalculator className="h-5 w-5" />,
    component: <SalaryStructure />,
    showInSidebar: true,
    group: "Payroll Management",
    feature: "payroll",
    permissionModule: "salary_structure",
    // allowedRoles: ["Company"],
  },
  {
    name: "Monthly Salary Configuration",
    layout: "/company",
    path: "salary-configuration",
    icon: <MdSettingsAccessibility className="h-5 w-5" />,
    component: <SalaryConfiguration />,
    showInSidebar: true,
    group: "Payroll Management",
    feature: "payroll",
    permissionModule: "salary_configuration",
    // allowedRoles: ["Company"],
  },
  {
    name: "Salary Disbursement",
    layout: "/company",
    path: "process-payroll",
    icon: <FaRupeeSign className="h-5 w-5" />,
    component: <ProcessPayroll />,
    showInSidebar: true,
    group: "Payroll Management",
    feature: "payroll",
    permissionModule: "payroll",
    // allowedRoles: ["Company"],
  },

  // PROJECT MANAGEMENT COMPANY
  {
    name: "Overview",
    layout: "/company",
    path: "overview",
    icon: <MdOutlineDashboardCustomize className="h-5 w-5" />,
    component: <Overview />,
    showInSidebar: true,
    group: "Project Management",
    feature: "projects",
    permissionModule: "overview",
  },
  {
    name: "Projects",
    layout: "/company",
    path: "projects",
    icon: <MdFolderOpen className="h-5 w-5" />,
    component: <Project />,
    showInSidebar: true,
    group: "Project Management",
    feature: "projects",
    permissionModule: "projects",
  },

  {
    name: "Project Details",
    layout: "/company",
    path: "projects/:id",
    icon: <MdAssignmentInd className="h-5 w-5" />,
    component: <ProjectDetails />,
    showInSidebar: false,
    group: "Project Management",
  },
  {
    name: "Tasks",
    layout: "/company",
    path: "tasks",
    icon: <FaTasks className="h-5 w-5" />,
    component: <Task />,
    showInSidebar: true,
    group: "Project Management",
    feature: "projects",
    permissionModule: "tasks",
  },
  {
    name: "Reports",
    layout: "/company",
    path: "reports",
    icon: <MdPlaylistAddCheck className="h-5 w-5" />,
    component: <ProjectReport />,
    showInSidebar: true,
    group: "Project Management",
    feature: "projects",
    permissionModule: "project_report",
  },

  // ROLE MANAGEMENT COMPANY
  {
    name: "Get Roles",
    layout: "/company",
    path: "company-role",
    icon: <MdAssignmentInd className="h-5 w-5" />,
    component: <CompanyRole />,
    showInSidebar: true,
    group: "Role Management",
    feature: "auth",
    permissionModule: "role",
    allowedRoles: ["Company"],
  },
  {
    name: "Role Permissions",
    layout: "/company",
    path: "assign-roles",
    icon: <MdRule className="h-5 w-5" />,
    component: <RolePermission />,
    showInSidebar: true,
    group: "Role Management",
    feature: "auth",
    permissionModule: "role_permission",
    allowedRoles: ["Company"],
  },
  {
    name: "Employee Roles",
    layout: "/company",
    path: "employee-roles",
    icon: <MdAdminPanelSettings className="h-5 w-5" />,
    component: <EmployeeRoles />,
    showInSidebar: true,
    group: "Role Management",
    feature: "auth",
    permissionModule: "employee_role",
    allowedRoles: ["Company"],
  },

  // REQUISITION MODULE
  {
    name: "Requisitions",
    layout: "/company",
    path: "requisitions",
    icon: <FaFileInvoiceDollar className="h-5 w-5" />,
    component: <Requisitions />,
    showInSidebar: true,
    group: "Requisition Management",
    // feature: "employees",
    permissionModule: "requisition.approve",
  },
  {
    name: "My Requisitions",
    layout: "/company",
    path: "my-requisitions",
    icon: <FaFileInvoiceDollar className="h-5 w-5" />,
    component: <MyRequisitions />,
    showInSidebar: true,
    group: "Requisition Management",
    // feature: "employees",
    // allowedRoles: ["Employee"],
    permissionModule: "requisition",
  },
  {
    name: "Create Requisition",
    layout: "/company",
    path: "requisition-create",
    icon: <MdOutlineAddBox className="h-5 w-5" />,
    component: <CreateRequisition />,
    showInSidebar: true,
    group: "Requisition Management",
    // feature: "employees",
    permissionModule: "requisition",
  },
  {
    name: "Approval Workflows",
    layout: "/company",
    path: "requisition-workflows",
    icon: <FaSitemap className="h-5 w-5" />,
    component: <RequisitionWorkflows />,
    showInSidebar: true,
    group: "Requisition Management",
    allowedRoles: ["Company"],
    permissionModule: "requisition",
  },

  // EMPLOYEE DASHBOARD
  // {
  //   name: "Dashboard",
  //   layout: "/admin",
  //   path: "dashboard",
  //   icon: <FaHome className="h-5 w-5" />,
  //   component: <Dashboard />,
  //   showInSidebar: true,
  //   group: "Dashboard",
  //   allowedRoles: ["SUPER_ADMIN"],
  // },
  // COMPANY & EMPLOYEE SETTINGS
  {
    name: "Settings",
    layout: "/company",
    path: "settings",
    icon: <MdSettings className="h-5 w-5" />,
    component: <Settings />,
    showInSidebar: false,
    allowedRoles: ["Company", "Employee"],
  },
];

export default routes;
